//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {
  mdiChevronLeft,
  mdiChevronRight,
  mdiTrashCanOutline,
  mdiEmailOutline,
  mdiFolderOutline,
  mdiLabelOutline,
  mdiArrowExpandVertical,
  mdiArrowCollapseVertical,
  mdiDotsVertical,
} from '@mdi/js'
// eslint-disable-next-line object-curly-newline
import { computed, nextTick, ref, watch } from '@vue/composition-api'
import { PerfectScrollbar } from 'vue2-perfect-scrollbar'
import { psScrollToBottom, psScrollToTop } from '@core/utils'
import useEmail from './useEmail'

// Local Components
import EmailMessageCard from './EmailMessageCard.vue'

export default {
  components: {
    PerfectScrollbar,

    // Local Components
    EmailMessageCard,
  },
  props: {
    emailViewData: {
      type: Object,
      required: true,
    },
    opendedEmailMeta: {
      type: Object,
      required: true,
    },
  },
  setup(props) {
    // ————————————————————————————————————
    //* ——— useEmail
    // ————————————————————————————————————

    const { resolveLabelColor, moveToFolderMenuListItems, updateLabelMenuListItems } = useEmail()

    // ————————————————————————————————————
    //* ——— Threading
    // ————————————————————————————————————

    const psEmailViewContent = ref(null)
    const psEmailViewContentScrollToBottom = psScrollToBottom(psEmailViewContent)
    const psEmailViewContentScrollToTop = psScrollToTop(psEmailViewContent)
    const showWholeThread = ref(false)

    // Reset expanded thread when email change
    watch(
      () => props.emailViewData.id,
      () => {
        showWholeThread.value = false
      },
    )

    // Scroll to bottom when all emails are expanded
    watch(showWholeThread, val => {
      nextTick(() => {
        if (val) psEmailViewContentScrollToBottom()
        else psEmailViewContentScrollToTop()
      })
    })

    // Messages wrapper styles
    const messagesWrapperStyles = computed(() => {
      if (!showWholeThread.value && props.emailViewData.replies && props.emailViewData.replies.length) {
        return {
          marginTop: `${(props.emailViewData.replies.length + 2) * 4}px !important`,
        }
      }

      return null
    })

    // Style for replies preview (UI)
    const threadStyles = computed(() => (replyIndex, total) => {
      const styles = {}
      const reverseIndex = total - replyIndex - 1

      styles.opacity = 1 - (reverseIndex + 1) * 0.25
      styles.width = `${100 - (reverseIndex + 1) * 5}%`

      return styles
    })

    // ————————————————————————————————————
    //* ——— Perfect Scrollbar
    // ————————————————————————————————————

    const perfectScrollbarSettings = {
      maxScrollbarLength: 60,
      wheelPropagation: false,
    }

    return {
      // useEmail
      resolveLabelColor,
      moveToFolderMenuListItems,
      updateLabelMenuListItems,

      // Threading
      psEmailViewContent,
      showWholeThread,
      threadStyles,
      messagesWrapperStyles,

      // Perfect Scrollbar
      perfectScrollbarSettings,

      // Icons
      icons: {
        mdiChevronLeft,
        mdiChevronRight,
        mdiTrashCanOutline,
        mdiEmailOutline,
        mdiFolderOutline,
        mdiLabelOutline,
        mdiArrowExpandVertical,
        mdiArrowCollapseVertical,
        mdiDotsVertical,
      },
    }
  },
}
